<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/dashboard'"
            >Dashboard</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="
        display: flex;
        justify-content: center;
        flex-flow: wrap;
        margin-top: 20px;
        padding: 40px;
      "
    >
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
        style=""
      >
        <router-link :to="'/' + authUser.userable_type + '/projects'">
          <stat-card
            style="
              border-top-left-radius: 40px;
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              border-bottom-left-radius: 0px;
            "
          >
            <template slot="image">
              <img :src="'data:image/svg+xml;base64,' + projectImage" alt="" />
            </template>
            <template slot="title">
              <p style="text-align: center">Projects</p>
            </template>
            <template slot="count">
              <h3>{{ statistics["projectCount"] }}</h3>
            </template>
          </stat-card>
        </router-link>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
        style=""
      >
        <router-link :to="'/' + authUser.userable_type + '/clusters'">
          <stat-card style="border-radius: 0">
            <template slot="image">
              <img :src="'data:image/svg+xml;base64,' + clusterImage" alt="" />
            </template>
            <template slot="title">
              <p style="text-align: center">Clusters</p>
            </template>
            <template slot="count">
              <h3>{{ statistics["clusterCount"] }}</h3>
            </template>
          </stat-card>
        </router-link>
      </div>

      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <router-link :to="'/' + authUser.userable_type + '/assets'">
          <stat-card
            style="
              border-top-left-radius: 0px;
              border-top-right-radius: 40px;
              border-bottom-right-radius: 0px;
              border-bottom-left-radius: 0px;
            "
          >
            <template slot="image">
              <img :src="'data:image/svg+xml;base64,' + assetImage" alt="" />
            </template>
            <template slot="title">
              <p style="text-align: center">Assets</p>
            </template>
            <template slot="count">
              <h3>{{ statistics["assetCount"] }}</h3>
            </template>
          </stat-card>
        </router-link>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
        style=""
      >
        <router-link :to="'/' + authUser.userable_type + '/plans'">
          <stat-card
            style="
              border-top-left-radius: 0px;
              border-top-right-radius: 0px;
              border-bottom-right-radius: 0px;
              border-bottom-left-radius: 40px;
            "
          >
            <template slot="image">
              <img :src="'data:image/svg+xml;base64,' + planImage" alt="" />
            </template>
            <template slot="title">
              <p style="text-align: center">Plans</p>
            </template>
            <template slot="count">
              <h3>{{ statistics["planCount"] }}</h3>
            </template>
          </stat-card>
        </router-link>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
        style=""
      >
        <router-link :to="'/' + authUser.userable_type + '/investors'">
          <stat-card style="border-radius: 0">
            <template slot="image">
              <img :src="'data:image/svg+xml;base64,' + investorImage" alt="" />
            </template>
            <template slot="title">
              <p style="text-align: center">Investors</p>
            </template>
            <template slot="count">
              <h3>{{ statistics["investorCount"] }}</h3>
            </template>
          </stat-card>
        </router-link>
      </div>
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-33"
      >
        <router-link
          :to="'/' + authUser.userable_type + '/investors/contracts'"
        >
          <stat-card
            style="
              border-top-left-radius: 0px;
              border-top-right-radius: 0px;
              border-bottom-right-radius: 40px;
              border-bottom-left-radius: 0px;
            "
          >
            <template slot="image">
              <img :src="'data:image/svg+xml;base64,' + contractImage" alt="" />
            </template>
            <template slot="title">
              <p style="text-align: center">Contracts</p>
            </template>
            <template slot="count">
              <h3>{{ statistics["contractCount"] }}</h3>
            </template>
          </stat-card>
        </router-link>
      </div>
    </div>
    <div style="display: flex; padding: 0 40px">
      <div class="col-6">
        <md-card
          class="md-card-stats"
          style="
            background-color: white;
            border-radius: 15px;
            padding: 25px;
            height: 300px;
          "
        >
          <h5>Clusters Allocations</h5>

          <spinner style="margin-top: 60px" v-if="searchingClusters" />
          <pie-chart
            v-else
            style="height: 200px"
            :chart-data="clustersPieChartData"
            :options="chartOptions"
          ></pie-chart>
        </md-card>
      </div>
      <div class="col-6">
        <md-card
          class="md-card-stats"
          style="
            background-color: white;
            border-radius: 15px;
            padding: 25px;
            height: 300px;
          "
        >
          <h5>Assets Allocations</h5>

          <spinner style="margin-top: 60px" v-if="searchingAssets" />
          <pie-chart
            v-else
            style="height: 200px"
            :chart-data="assetsPieChartData"
            :options="chartOptions"
          ></pie-chart>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import StatCard from "../../components/Cards/StatsCard.vue";
import ChartCard from "../../components/Cards/ChartCard.vue";
import NavTabsCard from "../../components/Cards/NavTabsCard.vue";
import { getStorageMediaFile } from "../../api/directapi";
import StorageMediaFileFilter from "../../filters/StorageMediaFileFilter";
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import { PieChart } from "../../components/ChartJS";
export default {
  components: {
    StatCard,
    ChartCard,
    NavTabsCard,
    Spinner,
    PieChart,
  },

  data() {
    return {
      clusterImage: null,
      assetImage: null,
      projectImage: null,
      investorImage: null,
      contractImage: null,
      planImage: null,
      clustersPieChartData: {
        labels: [],
        datasets: [],
      },
      assetsPieChartData: {
        labels: [],
        datasets: [],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: true,
          position: "left",
        },
        tooltips: {
          displayColors: false,
          callbacks: {
            label: function (tooltipItem, data) {
              let dataset = data.datasets[tooltipItem.datasetIndex];
              let currentValue = dataset.data[tooltipItem.index];
              return (
                data.labels[tooltipItem.index] +
                " (" +
                currentValue +
                "%)"
              );
            },
          },
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
      },
    };
  },
  created: function () {
    this.$store.dispatch("getDashboardStatistics");
    this.$store.dispatch("searchClusters");
    this.$store.dispatch("searchAssets");
    let storageMediaFileFilter = StorageMediaFileFilter();
    storageMediaFileFilter.names = [
      "Cluster_Icon.svg",
      "Project_Icon.svg",
      "Asset_Icon.svg",
      "Contract_Icon.svg",
      "Partner_Icon.svg",
      "Plan_Icon.svg",
    ];
    getStorageMediaFile(storageMediaFileFilter).then((response) => {
      this.clusterImage = response.body.results.images.Cluster_Icon;
      this.projectImage = response.body.results.images.Project_Icon;
      this.assetImage = response.body.results.images.Asset_Icon;
      this.investorImage = response.body.results.images.Contract_Icon;
      this.contractImage = response.body.results.images.Partner_Icon;
      this.planImage = response.body.results.images.Plan_Icon;
    });
  },
  methods: {},
  computed: {
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      statistics: (state) => state.appStore.dashboardStatistics.statistics,
      searchingClusters: (state) =>
        state.clusterStore.clusterSearch.searchingClusters,
      clusters: (state) => state.clusterStore.clusterSearch.clusters,
      searchingAssets: (state) => state.assetStore.assetSearch.searchingAssets,
      assets: (state) => state.assetStore.assetSearch.assets,
    }),
  },
  watch: {
    clusters() {
      if (this.clusters && this.clusters.length > 0) {
        var labels = [];
        var data = [];
        this.clusters.forEach((cluster) => {
          labels.push(cluster.name);
          data.push(cluster.cluster_allocation_ratio.toFixed(2));
        });
        this.clustersPieChartData.labels = labels;
        this.clustersPieChartData.datasets = [
          {
            label: "Cluster Allocations",
            data: data,
            backgroundColor: [
              "#8cc63f",
              "rgb(255, 99, 132)",
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
              "rgb(32, 133, 236)",
              "rgb(114, 180, 235)",
              "rgb(10, 65, 122)",
              "rgb(132, 100, 160)",
              "rgb(206, 169, 188)",
              "rgb(50, 50, 50)",
              "rgb(223, 199, 49)",
              "rgb(234, 136, 216)",
              "rgb(17, 51, 103)",
              "rgb(151, 105, 142)",
              "rgb(186, 199, 193)",
              "rgb(60, 60, 60)",
            ],
            hoverOffset: 4,
          },
        ];
      }
    },
    assets() {
      if (this.assets && this.assets.length > 0) {
        var labels = [];
        var data = [];
        this.assets.forEach((asset) => {
          labels.push(asset.name);
          data.push(asset.asset_allocation_ratio.toFixed(2));
        });
        this.assetsPieChartData.labels = labels;
        this.assetsPieChartData.datasets = [
          {
            label: "Cluster Allocations",
            data: data,
            backgroundColor: [
              "#8cc63f",
              "rgb(255, 99, 132)",
              "rgb(54, 162, 235)",
              "rgb(255, 205, 86)",
              "rgb(32, 133, 236)",
              "rgb(114, 180, 235)",
              "rgb(10, 65, 122)",
              "rgb(132, 100, 160)",
              "rgb(206, 169, 188)",
              "rgb(50, 50, 50)",
              "rgb(223, 199, 49)",
              "rgb(234, 136, 216)",
              "rgb(17, 51, 103)",
              "rgb(151, 105, 142)",
              "rgb(186, 199, 193)",
              "rgb(60, 60, 60)",
            ],
            hoverOffset: 4,
          },
        ];
      }
    },
  },
};
</script>
<style>
</style>



// WEBPACK FOOTER //
// resources/js/pages/admin/dashboard.vue